import { Component, OnInit } from '@angular/core';
import { Session } from '../services';
import { Router } from '@angular/router';

@Component({
  selector: 'psychiatry-prescription-policy',
  templateUrl: './psychiatry-prescription-policy.component.html',
  styleUrls: ['./psychiatry-prescription-policy.component.css']
})
export class PsychiatryPrescriptionPolicyComponent implements OnInit {

  constructor(public session: Session, private router: Router) { }

	requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
	}
	
	gotoDashboard() {
		this.router.navigate(['/dashboard-medical/3']);
	}

  ngOnInit() {
  }

  

}
